import { Injectable } from "@angular/core";
import { AddPaymentMethodConfig } from "../actions/add-payment-method/model/add-payment-method-config.model";
import { Observable, of } from "rxjs";
import { DwModalButtonStandardConfigs, DwModalConfig, DwModalResult, DwModalService, DwModalSize } from "@devwareapps/devware-cap";
import { AddCardModalComponent } from "../components/add-card-modal/add-card-modal.component";
import { PaymentAddCardResult } from "../models/payment-add-card-result.model";
import { tap } from "rxjs/operators";



@Injectable({
    providedIn: 'root'
})
export class PaymentMethodUtilService {

    private static showingModal = false;
    constructor(private dwModalService: DwModalService) { }

    public showAddCardModal(addPaymentMethodConfig: AddPaymentMethodConfig): Observable<DwModalResult<PaymentAddCardResult>> {

        if (PaymentMethodUtilService.showingModal) {
            return of({ cancelled: true } as DwModalResult<PaymentAddCardResult>);
        }

        PaymentMethodUtilService.showingModal = true;


        let modalConfig = new DwModalConfig();

        modalConfig.title = "Add Card";
        modalConfig.component = AddCardModalComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndClose;

        modalConfig.buttons[0].buttonText = "Add Card";
        modalConfig.preventClose = false;
        modalConfig.data = addPaymentMethodConfig;

        // modalConfig.modalSize = DwModalSize.custom;
        // modalConfig.customModalWidth = '600px';
        // modalConfig.customModalHeight = '800px';

        modalConfig.modalSize = DwModalSize.responsive;

        return this.dwModalService.showModal(modalConfig)
            .pipe(tap(() => {
                PaymentMethodUtilService.showingModal = false;
            }));
    }


}